// extracted by mini-css-extract-plugin
export default {"storyCanvas":"StoryCanvasPreview_storyCanvas__ahI76","canvas":"StoryCanvasPreview_canvas__L7plL"};